import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section header */}
        <div className="mb-12 md:mb-16">
          <span className="text-xs md:text-sm text-foreground-400 font-medium tracking-wider uppercase">
            {t('categories.label')}
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight">
            {t('categories.title_line1')}
            <br />
            {t('categories.title_line2')}
          </h2>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 border border-background-200/40 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-background-50 border border-background-200/50 text-foreground-600 group-hover:text-primary-500 group-hover:border-primary-200/50 transition-colors">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {t(cat.nameKey)}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {t(cat.descKey)}
                  </p>
                </div>
                <span className="mt-1 text-foreground-300 group-hover:text-primary-400 transition-colors">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}